// extracted by mini-css-extract-plugin
export var footerLink = "eUePL";
export var footerText = "uL9BF";